var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('BaseFooter'),_c('div',{staticClass:"billing",class:_vm.$mq},[_c('img',{attrs:{"src":require("@/assets/images/footer/billing.png"),"alt":""}})]),_c('BasePress')],1)}
var staticRenderFns = []

export { render, staticRenderFns }